import React from "react";
import loading from "./loader.svg";

const Loader = (props) => {
    const classes = props.natural ? "loader" : "loader -abs-center";

    return (
        <div className={classes}>
            <img src={loading} alt="loading" />
        </div>
    );
};

export default Loader;
